<template>
  <section class="cta-section">
    <div class="container">
      <div class="cta-box" v-reveal>
        <div class="cta-glow" aria-hidden="true"></div>
        <div class="cta-content">
          <h2>有一个想法，想让它落地？</h2>
          <p>告诉我们您的需求，资深项目经理将在 24 小时内与您沟通，免费提供方案与报价。</p>
          <div class="cta-actions">
            <router-link to="/contact" class="btn cta-btn">立即免费咨询</router-link>
            <a :href="`tel:${site.phone.replace(/-/g, '')}`" class="btn cta-tel">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
                <path
                  d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.1 4.2 2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.13.96.36 1.9.7 2.8a2 2 0 0 1-.45 2.1L8.1 9.9a16 16 0 0 0 6 6l1.3-1.3a2 2 0 0 1 2.1-.45c.9.34 1.84.57 2.8.7a2 2 0 0 1 1.7 2z"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              {{ site.phone }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import site from '@/data/site'
</script>

<style scoped>
.cta-section {
  padding: 40px 0 96px;
  background: #fff;
}

.cta-box {
  position: relative;
  overflow: hidden;
  border-radius: 24px;
  background: linear-gradient(135deg, var(--hl-blue) 0%, #0d2a9e 55%, var(--hl-dark) 100%);
  padding: 64px 48px;
  text-align: center;
  box-shadow: 0 30px 70px rgba(11, 92, 255, 0.35);
}

.cta-glow {
  position: absolute;
  width: 420px;
  height: 420px;
  border-radius: 50%;
  top: -180px;
  left: 50%;
  transform: translateX(-50%);
  background: radial-gradient(circle, rgba(53, 194, 247, 0.45), transparent 65%);
  animation: pulseGlow 6s ease-in-out infinite;
  pointer-events: none;
}

.cta-content {
  position: relative;
  z-index: 1;
}

.cta-content h2 {
  font-size: 34px;
  font-weight: 800;
  color: #fff;
  letter-spacing: 1px;
}

.cta-content p {
  margin: 16px auto 0;
  max-width: 520px;
  font-size: 16px;
  color: rgba(255, 255, 255, 0.78);
}

.cta-actions {
  margin-top: 32px;
  display: flex;
  justify-content: center;
  gap: 16px;
  flex-wrap: wrap;
}

.cta-btn {
  background: #fff;
  color: var(--hl-blue);
  box-shadow: 0 10px 30px rgba(5, 15, 40, 0.3);
}

.cta-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 16px 36px rgba(5, 15, 40, 0.4);
}

.cta-tel {
  border: 1px solid rgba(255, 255, 255, 0.55);
  color: #fff;
  background: rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(6px);
}

.cta-tel:hover {
  background: rgba(255, 255, 255, 0.18);
  transform: translateY(-2px);
}

.cta-tel svg {
  width: 17px;
  height: 17px;
}

@media (max-width: 768px) {
  .cta-box {
    padding: 44px 24px;
  }
  .cta-content h2 {
    font-size: 24px;
  }
}
</style>
